import _ from "underscore";

import api from "@/helpers/api";
import auth from "@/helpers/auth";
import realtime from "@/helpers/realtime";

const apiVersion = 'v1';
const source = 'messages';

export default {
  state: {
    // Messages are grouped by conversation ID
    conversations: {}
  },

  mutations: {
    setMessagesForConversationId(state, { conversationId, messages }) {
      state.conversations[conversationId] = messages;
    },

    createConversation(state, { conversationId }) {
      state.conversations[conversationId] = [];
    },

    addMessageToConversation(state, { conversationId, message }) {
      const hasMessage = _.findWhere(state.conversations[conversationId], { id: message.id });

      if (hasMessage) {
        console.log("Already has message with ID ", message.id);
        return;
      }

      state.conversations[conversationId].push(message);
    }
  },

  actions: {
    fetchMessages({ commit, state }, conversationId) {
      // Already got the messages
      if (state.conversations[conversationId]) return;

      const params = {
        team_id: auth.teamId(),
        sort_by: "created_at",
        sort_order: "desc",
        per_page: 1000 // TODO: fetch fewer, and paginate on scroll up?
      };

      return api
        .instance()
        .get(`${apiVersion}/conversations/${conversationId}/${source}`, { params })
        .then((resp) => {
          const messages = _.map(resp.data.data, (msg) => msg.attributes).reverse();
          commit("setMessagesForConversationId", { conversationId, messages });
        });
    },

    postMessage({ commit, getters }, { conversationId, message }) {
      const params = {
        team_id: auth.teamId(),
        conversation_id: conversationId,
        content: message
      };

      return api
        .instance()
        .post(`${apiVersion}/${source}`, params)
        .then((resp) => {
          commit("addMessageToConversation", { conversationId, message: resp.data.data.attributes });
        })
        .catch((err) => console.error("Failed to post message", err));
    },

    connectRealtimeMessages({ commit, state }, teamId) {
      const channelName = `private-team-${teamId}`;

      realtime.subscribe(channelName, "new-message", (data) => {
        const message = data.data.attributes;
        console.log("Pusher: new-message", message);

        if (!state.conversations[message.conversation_id]) {
          commit("createConversation", { conversationId: message.conversation_id });
        }

        commit("addMessageToConversation", { conversationId: message.conversation_id, message: message });
      });
    }
  },

  getters: {
    messagesForConversation(state) {
      return (id) => {
        const messages = state.conversations[id];
        return _.isArray(messages) ? messages : [];
      };
    }
  }
};
